<template>
    <div class="bills-head">
        <p class="nav">
            <!-- 未登录返回到我们的提示登录页 -->
            <router-link v-if="isBillSearch && !isLogin" class="icon-back" :to="{ name: 'waybill' }">
                <icon name="to-left"></icon>
            </router-link>
            <!-- 已登录返回到cx的列表页 -->
            <span v-if="isLogin" class="icon-back" @click="backToCx">
                <icon name="to-left"></icon>
            </span>
            <a v-if="!isBillSearch && !isLogin" :href="getURLWithContext('index.html')" class="icon-back">
                <icon name="to-left"></icon>
            </a>
            <span class="bills-title">运单追踪</span>
            <router-link v-show="showSearch" class="icon-search-wrapper" :to="{ path: 'waybill/search' }">
                <icon name="search"></icon>
            </router-link>
        </p>
    </div>
</template>

<script>
import { getURLWithContext, getCookie } from '../../util/util'
import { urls } from '@/constant/paths'
import loginType from '@/constant/loginType'
import ajax from '@/api/ajax'

export default {
    name: 'WaybillHeader',
    props: ['showSearch', 'isBillSearch'], // 头部
    data() {
        return {
            isLogin: getCookie('loginUser')
        }
    },
    methods: {
        getURLWithContext,
        backToCx() {
            return ajax
                .getTicket({
                    params: { ts: new Date().getTime() }
                })
                .then(res => {
                    if (res.data.code == 0) {
                        const ticket = res.data.result
                        const href = `${urls.MP_CHECK_TICKET}?type=${loginType.WX_QUERY}&ticket&ticket=${ticket}`
                        window.location.href = href
                    }
                })
        }
    }
}
</script>

<style lang="scss" scoped>
.bills-head {
    background: $white;
    padding: 0 0.2rem;
    .nav {
        height: 0.8rem;
        line-height: 0.8rem;
        text-align: center;
        position: relative;
        margin-top: 0.2rem;
    }
    .icon-back {
        position: absolute;
        left: 0;
        width: 0.4rem;
    }
    .bills-title {
        font-size: 0.4rem;
    }
    .icon-search-wrapper {
        position: absolute;
        right: 0;
        width: 0.3rem;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/waybill/waybill-header.vue